/**
 * Integrytas Group — shared "design editor has unsaved changes" flag.
 *
 * The design editors (FieldRenderer's DesignEditorPanel / SectionedDesignEditorPanel)
 * set this while their working arrangement diverges from the saved layout, and clear
 * it on Apply / Cancel / unmount. PersonalizationToggle reads it to guard exiting
 * personalize mode so a page's unsaved layout changes aren't silently discarded.
 *
 * Module-level (only one design session is active at a time) and subscribable so the
 * toggle can reflect the dirty state reactively.
 */

let _dirty = false;
const _subs = new Set<() => void>();

export function setDesignDirty(value: boolean): void {
  if (_dirty === value) return;
  _dirty = value;
  for (const fn of [..._subs]) fn();
}

export function isDesignDirty(): boolean {
  return _dirty;
}

export function subscribeDesignDirty(fn: () => void): () => void {
  _subs.add(fn);
  return () => { _subs.delete(fn); };
}
